module.exports = __webpack_public_path__ + "static/media/icon_15.1d24cf5c.svg";